'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
exports.default = eauors;
var _ramda = require('ramda');
var _utils = require('../utils');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function legendUpdate(selection, options, accessors) {
  selection.attr({
    width: accessors.width(options),
    height: accessors.height(options)
  });
}
function axisEnter(selection, axis, options) {
  var legendOptions = (0, _ramda.pathOr)({}, ['legend', 'choropleth'], options);
  selection.call(axis);
  selection.selectAll('path').style((0, _utils.lineStyle)((0, _ramda.prop)('axis', legendOptions)));
  selection.selectAll('line').style((0, _utils.lineStyle)((0, _ramda.path)(['axis', 'tick'], legendOptions)));
  selection.selectAll('text').style((0, _utils.fontStyle)((0, _ramda.path)(['axis', 'font'], legendOptions)));
}
function axisUpdate(selection, options, offset, computors) {
  selection.attr('transform', computors.axisTranslate(offset, options));
}
function colorEnter(selection, selectors) {
  (0, _utils.setupElement)(selection, 'svg:rect', selectors.colors);
}
function colorUpdate(selection) {
  selection.attr({
    x: function x(datum) {
      return datum.x;
    },
    y: function y(datum) {
      return datum.y;
    },
    width: function width(datum) {
      return datum.width;
    },
    height: function height(datum) {
      return datum.height;
    }
  }).style({
    fill: function fill(datum) {
      return datum.color;
    }
  });
}
function eauors(target) {
  target.eauors = (0, _extends3.default)({}, target.eauors, {
    axisEnter: axisEnter,
    axisUpdate: axisUpdate,
    colorEnter: colorEnter,
    colorUpdate: colorUpdate,
    legendUpdate: legendUpdate
  });
}